import { render, staticRenderFns } from "./ChannelRouteRemoveModal.vue?vue&type=template&id=34ad43a1"
import script from "./ChannelRouteRemoveModal.vue?vue&type=script&lang=js"
export * from "./ChannelRouteRemoveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports